define([
	"dojo/_base/declare",
	"csi/action/AggregateController",
	"BusinessPlanning/ProductPlanProductMixin"
], function(declare,AggregateController,ProductPlanProductMixin) {

	return declare([AggregateController, ProductPlanProductMixin], {
		constructor: function(/*Object*/params) {
			//Summary: Initialize variable
			var actionId = this.m_action.m_id;
			if(actionId == "SelectColorway") {
				this.productClass = this._STYLE;
				this.__aggregateClassId = this._PRODUCT_COLOR;
			} else if(actionId == "SelectColorMaterial") {
				this.productClass = this._MATERIAL;
				this.__aggregateClassId = this._PRODUCT_COLOR;
			} else if (this.m_action.m_id == "SelectMaterial")
				this.productClass = this._MATERIAL;
			else if(this.m_action.m_id == "SelectStyle")
				this.productClass = this._STYLE;
		},

		applyActionFilters: function(/*csi.view.Widget*/view) {
			// summary: apply filters for action BusinessPlan new BPProductPlan from Material
			var query = this._getQuery();
			if (query)
				view.relRoot.addQuery(query);

			this.inherited(arguments);
		},

		postProcessSuccess: function() {
			// summary: refresh row
			this.widget.redrawNode(this.refNode);
		}
	});
});